import axios, { AxiosResponse } from "axios";


export const createContent = (data: any, serviceUrl: string): Promise<AxiosResponse> => {
  return axios.post(serviceUrl, data);
};
